import { ActivatedRoute } from '@angular/router';
import { ClaimService } from './../claim.service';
import { Component, OnInit } from '@angular/core';
import { CustomLoadingService } from 'src/app/shared/custom-loading/custom-loading.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { EmailComponent } from 'src/app/shared/component/email/email.component';
import { AppSettingService } from 'src/app/services/app-setting.service';
declare var myExtObject: any;
@Component({
  selector: 'app-patient-history',
  templateUrl: './patient-history.component.html',
  styleUrls: ['./patient-history.component.css']
})
export class PatientHistoryComponent implements OnInit {
  title: any = "History"
  userId: any = 0
  claimUri: any
  errorMessage:any="";
  showAddClaim: any = false;
  selectedAll:any= true
  success: any = "EmailSent"
  patientHistory: any = []
  showEmail:any=false
  constructor(
    public dialog: MatDialog,
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
     private claimService: ClaimService, 
     private appSettingService: AppSettingService,
     private loadingService: CustomLoadingService) {
    this.activatedRoute.params.subscribe(params => {
      this.userId = params["id"]
      this.claimUri = "/claims/new/" + this.userId
    })


  }
  selectAllClaim() {
    for (var i = 0; i < this.patientHistory.PatientHistory.length; i++) {
      this.patientHistory.PatientHistory[i].selected = this.selectedAll;
    }
  }
  isClaimSelected(): Boolean {

    var items = this.patientHistory.PatientHistory.filter(function (item: any) {
      return item.selected;
    });
    console.log(items.length)
    return items.length > 0;
  }
  selectClaim() {
    this.selectedAll = this.patientHistory.PatientHistory.every(function (item: any) {
      return item.selected == true;
    })
  }

  openDialog(): void {
    if (this.isClaimSelected()) {
      const dialogRef = this.dialog.open(EmailComponent, {
        width: 'auto', data: this.success
      });


      var componentInstance = dialogRef.componentInstance.sendEmailClicked.subscribe(res => {
        var emailForm = res.value;
        var items = this.patientHistory.PatientHistory.filter(function (item: any) {
          return item.selected;
        });
        var item = items.map(res =>
          res.ClaimID
        )
        emailForm.UserId = this.userId;
        emailForm.Claims = item;
        this.loadingService.show();
        this.claimService.emailClaims(res.value).subscribe(res => {
          this.loadingService.hide();
          dialogRef.componentInstance.success = this.translateService.instant("EmailDialog.Message.Success");
          // dialogRef.close();
        }, (error) => {

          dialogRef.componentInstance.success = this.translateService.instant("EmailDiallog.Message.Success");
          dialogRef.componentInstance.error = this.translateService.instant("EmailDiallog.Message.Failed");
          this.loadingService.hide();
        }, () => { });

      })

      dialogRef.beforeClosed().subscribe(

        data => {

          dialogRef.componentInstance.success = "";
          dialogRef.componentInstance.error = "";
          componentInstance.unsubscribe();

        }
      );
    }
    else{

      this.errorMessage="error";
    }
  }
  ngOnInit(): void {
    this.getPatientHistory();

  }
  delete(item: any) {

    if (confirm(this.translateService.instant("PatientHistory.Message.DeleteConfirm"))) {
      this.loadingService.show();
      this.claimService.deleteClaim(item.ClaimID).subscribe(res => {
        document.getElementById(item.ClaimID).remove();
      }, () => {
        this.loadingService.hide();
      }, () => {
        this.loadingService.hide();
      });
    }
  }
  getPatientHistory() {
    this.loadingService.show();
    this.claimService.getPatientHistory(this.userId).subscribe(res => {
      this.patientHistory = res;

      this.patientHistory.PatientHistory = this.patientHistory.PatientHistory.filter(function (item: any) {
        item.selected=true
        return  item
      });
      

      this.showAddClaim = res?.EnableAddClaim
      /*Added check for 1099 coach */
      if (this.appSettingService.loggedInUser.IsNetworkCoach == 'True')
      {
        this.showAddClaim=false;
      }
      else{
        this.showAddClaim=true;
      }

    }, () => { }, () => {
      this.loadingService.hide()
    })

  }
  print() {

    if (!this.isClaimSelected()) {
        this.errorMessage="error";

      return false;

    } else {
      myExtObject.Print();
    }
  }


}
